/**
 *
 * Question
 *
 */

import { mapGetters } from 'vuex';

import { swalWarning } from '@/utils/swal2';

// QaQuestionUpdateMixin
export const QaQuestionCommentMixin = {
  name: 'QaQuestionCommentMixin',

  props: {
    p_objQa: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isCanComment() {
      return this.mg_userInfo.isCurrentStudent;
    },
  },

  methods: {
    toggleComment() {
      if (!this.mg_userInfo.isCurrentStudent) {
        swalWarning('你是未付费用户不能评论');
      } else {
        this.updateObjQa(this.p_objQa, {
          i_commentIsOpen: !this.p_objQa.i_commentIsOpen,
        });
      }
    },
  },
};
